import { defineStore } from "pinia";
import type { Artwork } from "~~/types/artwork";
import { useMessage } from "./app-toast";

interface FollowStoreState {
    loading: boolean;
    fetching: boolean;
    favorites: Artwork[];
    favoriteIds: string[];
    currentId: string | null;
    isFollowing: boolean;
}

export const useFollowStore = defineStore("FollowStore", {
    state: (): FollowStoreState => ({
        loading: false,
        fetching: false,
        favorites: [],
        favoriteIds: [],
        currentId: null,
        isFollowing: false,
    }),
    actions: {
        async toggleFollow(
            followingId: string,
            followingEmail: string,
        ): Promise<void> {
            const toast = useMessage();
            const { $api } = useNuxtApp()
            try {
                this.loading = true;

                await $api(`/follow/toggle`, {
                    method: 'POST',
                    body: { followingId, followingEmail }
                });
                this.isFollowing = !this.isFollowing;
            } catch (e) {
                toast.error(e);
            } finally {
                this.loading = false;
                this.currentId = null;
            }
        },
        //
        async getFollowingStatus(followingId: string): Promise<void> {
            const { $api } = useNuxtApp()
            try {
                this.fetching = true;

                const data = await $api<any>(`/status/${followingId}`);
                this.isFollowing = data.following;
            } catch (_e) {
                this.isFollowing = false;
            } finally {
                this.fetching = false;
            }
        },
    },
});
